import React, { useEffect, useState } from "react";
import "./MasterDesignConfigure.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
import BackArrowIcon from "../../../../components/icons/BackArrowIcon";
import { TemplatesApi } from "../../../../utils/api/Templates";
import ProtectedComponent from "../../../../components/ProtectedComponent";
import NavigationLayout from "../../navigation";
import { clientRoutes } from "../../../../utils/routes";
import SelectDesignModal from "./SelectDesignModal";
import { LocalStorageHelpers } from "../../../../utils/helpers/localstorage.helpers";
import PropertyStagesDesignData from "../../../../components/image.tool/property.stages.design.data";
import {
  getAddress,
  getAgencyLogoUrl,
  getCdnImageUrl,
  getFontUrl,
} from "../../../../utils/helpers/common";
import { CommonUtils } from "../../../../utils/helpers/common.utils";
import PreviewModal from "../PreviewModal";
import AgencyData from "../../../../@types/agency.data";
import axiosInstance from "../../../../utils/api/Axios";
import DesignCardItem from "./DesignCardItem";
import { fetchStagesWithTitlesOnce, getSelectedStageDisplayTitle, mapDesignStageToPropertyStageSlug } from "../../../../utils/helpers/propertyStageDisplay.helpers";
import { PropertyApi } from "../../../../utils/api/Property";

let initialAgencyFontsData = {
  title: {
    font_300: {
      postscript_name: "ArchivoExpanded-Light",
      loaded: false,
      error: false,
    },
    font_300_italic: {
      postscript_name: "ArchivoExpanded-LightItalic",
      loaded: false,
      error: false,
    },
    font_400: {
      postscript_name: "ArchivoExpanded-Regular",
      loaded: false,
      error: false,
    },
    font_400_italic: {
      postscript_name: "ArchivoExpanded-Italic",
      loaded: false,
      error: false,
    },
    font_500: {
      postscript_name: "ArchivoExpanded-Medium",
      loaded: false,
      error: false,
    },
    font_500_italic: {
      postscript_name: "ArchivoExpanded-MediumItalic",
      loaded: false,
      error: false,
    },
    font_600: {
      postscript_name: "ArchivoExpanded-SemiBold",
      loaded: false,
      error: false,
    },
    font_600_italic: {
      postscript_name: "ArchivoExpanded-SemiBoldItalic",
      loaded: false,
      error: false,
    },
    font_700: {
      postscript_name: "ArchivoExpanded-Bold",
      loaded: false,
      error: false,
    },
    font_700_italic: {
      postscript_name: "ArchivoExpanded-BoldItalic",
      loaded: false,
      error: false,
    },
    font_800: {
      postscript_name: "ArchivoExpanded-ExtraBold",
      loaded: false,
      error: false,
    },
    font_800_italic: {
      postscript_name: "ArchivoExpanded-ExtraBoldItalic",
      loaded: false,
      error: false,
    },
    font_900: {
      postscript_name: "ArchivoExpanded-Black",
      loaded: false,
      error: false,
    },
    font_900_italic: {
      postscript_name: "ArchivoExpanded-BlackItalic",
      loaded: false,
      error: false,
    },
  },
  subtitle: {
    font_300: {
      postscript_name: "ArchivoExpanded-Light",
      loaded: false,
      error: false,
    },
    font_300_italic: {
      postscript_name: "ArchivoExpanded-LightItalic",
      loaded: false,
      error: false,
    },
    font_400: {
      postscript_name: "ArchivoExpanded-Regular",
      loaded: false,
      error: false,
    },
    font_400_italic: {
      postscript_name: "ArchivoExpanded-Italic",
      loaded: false,
      error: false,
    },
    font_500: {
      postscript_name: "ArchivoExpanded-Medium",
      loaded: false,
      error: false,
    },
    font_500_italic: {
      postscript_name: "ArchivoExpanded-MediumItalic",
      loaded: false,
      error: false,
    },
    font_600: {
      postscript_name: "ArchivoExpanded-SemiBold",
      loaded: false,
      error: false,
    },
    font_600_italic: {
      postscript_name: "ArchivoExpanded-SemiBoldItalic",
      loaded: false,
      error: false,
    },
    font_700: {
      postscript_name: "ArchivoExpanded-Bold",
      loaded: false,
      error: false,
    },
    font_700_italic: {
      postscript_name: "ArchivoExpanded-BoldItalic",
      loaded: false,
      error: false,
    },
    font_800: {
      postscript_name: "ArchivoExpanded-ExtraBold",
      loaded: false,
      error: false,
    },
    font_800_italic: {
      postscript_name: "ArchivoExpanded-ExtraBoldItalic",
      loaded: false,
      error: false,
    },
    font_900: {
      postscript_name: "ArchivoExpanded-Black",
      loaded: false,
      error: false,
    },
    font_900_italic: {
      postscript_name: "ArchivoExpanded-BlackItalic",
      loaded: false,
      error: false,
    },
  },
  body: {
    font_300: {
      postscript_name: "ArchivoExpanded-Light",
      loaded: false,
      error: false,
    },
    font_300_italic: {
      postscript_name: "ArchivoExpanded-LightItalic",
      loaded: false,
      error: false,
    },
    font_400: {
      postscript_name: "ArchivoExpanded-Regular",
      loaded: false,
      error: false,
    },
    font_400_italic: {
      postscript_name: "ArchivoExpanded-Italic",
      loaded: false,
      error: false,
    },
    font_500: {
      postscript_name: "ArchivoExpanded-Medium",
      loaded: false,
      error: false,
    },
    font_500_italic: {
      postscript_name: "ArchivoExpanded-MediumItalic",
      loaded: false,
      error: false,
    },
    font_600: {
      postscript_name: "ArchivoExpanded-SemiBold",
      loaded: false,
      error: false,
    },
    font_600_italic: {
      postscript_name: "ArchivoExpanded-SemiBoldItalic",
      loaded: false,
      error: false,
    },
    font_700: {
      postscript_name: "ArchivoExpanded-Bold",
      loaded: false,
      error: false,
    },
    font_700_italic: {
      postscript_name: "ArchivoExpanded-BoldItalic",
      loaded: false,
      error: false,
    },
    font_800: {
      postscript_name: "ArchivoExpanded-ExtraBold",
      loaded: false,
      error: false,
    },
    font_800_italic: {
      postscript_name: "ArchivoExpanded-ExtraBoldItalic",
      loaded: false,
      error: false,
    },
    font_900: {
      postscript_name: "ArchivoExpanded-Black",
      loaded: false,
      error: false,
    },
    font_900_italic: {
      postscript_name: "ArchivoExpanded-BlackItalic",
      loaded: false,
      error: false,
    },
  },
};

const STEP_MAPPING: any = {
  property_marketing_for_sale: [
    "coming_soon_property_marketing_for_sale",
    "for_sale_listing_property_marketing_for_sale",
    "auction_property_marketing_for_sale",
    "under_offer_property_marketing_for_sale",
    "open_home_property_marketing_for_sale",
  ],
  property_marketing_for_rent: [
    "coming_soon_property_marketing_for_rent",
    "for_rent_listing_property_marketing_for_rent",
    "open_home_property_marketing_for_rent",
    "deposit_taken_property_marketing_for_rent",
  ],
  agent_marketing_for_sale: [
    "sold_agent_marketing_for_sale",
    "review_post_agent_marketing_for_sale",
    "review_recap_agent_marketing_for_sale",
    "under_offer_recap_agent_marketing_for_sale",
    "sold_recap_agent_marketing_for_sale",
  ],
  agent_marketing_for_rent: [
    "leased_agent_marketing_for_rent",
    "review_post_agent_marketing_for_rent",
    "review_recap_agent_marketing_for_rent",
    "leased_recap_agent_marketing_for_rent",
  ],
};

const STEP_LABELS: any = {
  property_marketing_for_sale: "Property marketing for sale",
  property_marketing_for_rent: "Property marketing for rent",
  agent_marketing_for_sale: "Agent marketing for sale",
  agent_marketing_for_rent: "Agent marketing for rent",
};

const MasterDesignConfigure = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const type = searchParams.get("type");

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>(null);
  const [fullConfig, setFullConfig] = useState<any>(null);
  const [agencyData, setAgencyData] = useState<any>(null);

  const [viewMap, setViewMap] = useState<Record<string, "image" | "story">>({});

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStageData, setSelectedStageData] = useState<any>(null);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImages, setPreviewImages] = useState<string[]>([]);

  // const [stageConfigs, setStageConfigs] = useState([]);
    const [stageConfigs, setStageConfigs] = useState<any[]>([]);
    const [stagesLoading, setStagesLoading] = useState(false);

  const [designState, setDesignState] = useState({
    agencyData: null,
    brandData: null,
    useAgencyOfficeLogo: false,
    loading: true,
    downloadingFontsData: true,
    loadingFontsData: true,
    fontsToBeLoaded: [],
    agencyFontsData: initialAgencyFontsData,
  });

  const fetchData = async () => {
    if (!id) return;

    setLoading(true);

    const agencyData = LocalStorageHelpers.getAgencyData() as any;

    if (!agencyData) {
      setLoading(false);
      return;
    }

    setAgencyData(agencyData);

    const brandData = agencyData?.brand_id;
    const useAgencyOfficeLogo = agencyData?.use_office_logo ?? false;

    const getAgencyLogo = () => {
      if (brandData && !useAgencyOfficeLogo) {
        return getAgencyLogoUrl(brandData?.brand_logo);
      }

      return getAgencyLogoUrl(agencyData?.profile_image_ref);
    };

    const getColorsData = () => {
      const data = {
        base_color_primary: { hex: "" },
        base_color_secondary: { hex: "" },
        text_color_primary: { hex: "" },
        text_color_secondary: { hex: "" },
      };

      if (brandData && !useAgencyOfficeLogo) {
        data.base_color_primary.hex = brandData?.base_color_primary?.hex ?? "";
        data.base_color_secondary.hex =
          brandData?.base_color_secondary?.hex ?? "";
        data.text_color_primary.hex = brandData?.text_color_primary?.hex ?? "";
        data.text_color_secondary.hex =
          brandData?.text_color_secondary?.hex ?? "";
        return data;
      }

      data.base_color_primary.hex = agencyData?.base_color_primary?.hex ?? "";
      data.base_color_secondary.hex =
        agencyData?.base_color_secondary?.hex ?? "";
      data.text_color_primary.hex = agencyData?.text_color_primary?.hex ?? "";
      data.text_color_secondary.hex =
        agencyData?.text_color_secondary?.hex ?? "";
      return data;
    };

    const res = await TemplatesApi.getDesignTemplateConfigsById({
      design_template_id: id,
    });

    if (res?.data?.success) {
      const config = res.data.data?.[0];
      const selectedData = config?.design_record_id;

      setFullConfig(config);
      setData(selectedData);

      const initialViews: any = {};
      Object.values(STEP_MAPPING)
        .flat()
        .forEach((slug: any) => {
          initialViews[`${slug}-agent`] = "image";
          initialViews[`${slug}-agency`] = "image";
        });
      setViewMap(initialViews);

      if (selectedData) {
        let imageDesignData = JSON.parse(
          JSON.stringify(
            PropertyStagesDesignData.coming_soon_property_marketing_for_sale,
          ),
        );

        imageDesignData.agency_logo = { url: getAgencyLogo(), load: true };
        imageDesignData.agent_name = CommonUtils.getAgentName(
          agencyData.principal_agent_id,
        );
        imageDesignData.agent_email = agencyData.principal_agent_id?.email;
        imageDesignData.agent_phone =
          agencyData.principal_agent_id?.principal_agent_mobile_number;
        imageDesignData.agent_profile_image_path = {
          url: getCdnImageUrl(
            agencyData?.principal_agent_id?.profile_image_ref?.storage_key,
          ),
          load: true,
        };
        imageDesignData.agency_trading_name =
          agencyData?.agency_trading_name ?? "";
        imageDesignData.agency_address = getAddress({
          unit: agencyData?.address_unit_number ?? "",
          city: agencyData?.city ?? "",
          country: agencyData?.country ?? "",
          no: agencyData?.house_number ?? "",
          postCode: agencyData?.post_code ?? "",
          state: agencyData?.state ?? "",
          streetName: agencyData?.street_name ?? "",
        });

        imageDesignData.fonts = initialAgencyFontsData;
        const updatedColors = getColorsData();

        imageDesignData = {
          ...imageDesignData,
          base_color_primary: {
            r: 255,
            g: 0,
            b: 0,
            hex: updatedColors.base_color_primary?.hex,
          },
          base_color_secondary: {
            r: 255,
            g: 255,
            b: 255,
            hex: updatedColors.base_color_secondary?.hex,
          },
          text_color_primary: {
            r: 255,
            g: 255,
            b: 255,
            hex: updatedColors.text_color_primary?.hex,
          },
          text_color_secondary: {
            r: 255,
            g: 0,
            b: 0,
            hex: updatedColors.text_color_secondary?.hex,
          },
        };

        setDesignState(
          (prev) =>
            ({
              ...prev,
              agencyData,
              brandData,
              useAgencyOfficeLogo,
            }) as any,
        );
      }
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const getFontKeys = (fonts: any, postscriptName: string) => {
    const matches = [];
    for (const textType in fonts) {
      const textFonts = fonts[textType];
      for (const key in textFonts) {
        if (textFonts[key].postscript_name === postscriptName) {
          matches.push({ text_type: textType, key });
        }
      }
    }
    return matches;
  };

  const preloadFonts = async ({ fontsToBeLoaded, agencyFontsData }: any) => {
    const loadedFonts = [];
    const fonts = fontsToBeLoaded;

    setDesignState((prev) => ({
      ...prev,
      loadingFontsData: true,
      downloadingFontsData: false,
      fontsToBeLoaded: fontsToBeLoaded,
      agencyFontsData: agencyFontsData,
    }));

    let updatedFontsData = CommonUtils.cloneDeep(agencyFontsData);

    await Promise.all(
      fonts.map(async (font: any) => {
        let loadFont = font.load_font;
        if (!loadFont) return;

        let fontKeys = getFontKeys(updatedFontsData, font.postscript_name);
        let fontUrl = getFontUrl(font);

        try {
          const fontFace = new FontFace(
            font.postscript_name,
            `url(${fontUrl})`,
          );
          await fontFace.load();
          document.fonts.add(fontFace);
          loadedFonts.push(fontFace);

          fontKeys.forEach(({ text_type, key }) => {
            updatedFontsData[text_type][key].loaded = true;
            updatedFontsData[text_type][key].error = false;
          });
        } catch (error) {
          console.error(`Failed to load font: ${font.postscript_name}`, error);

          fontKeys.forEach(({ text_type, key }) => {
            updatedFontsData[text_type][key].loaded = false;
            updatedFontsData[text_type][key].error = true;
          });
        }
      }),
    );

    setDesignState((prev) => ({
      ...prev,
      loadingFontsData: false,
      downloadingFontsData: false,
      agencyFontsData: updatedFontsData,
    }));
  };

  const getSystemFontVariantsForMainFont = async ({
    mainFontId,
  }: {
    mainFontId: string;
  }) => {
    try {
      const res = await axiosInstance.get(
        `/system-fonts/variants/for-main-font`,
        {
          params: { main_font_id: mainFontId },
        },
      );
      return { success: true, data: res.data?.data?.docs };
    } catch (err: any) {
      return {
        success: false,
        error:
          err?.response?.data?.message ||
          "Something went wrong while fetching brand settings!",
        data: err?.response?.data,
      };
    }
  };

  const getBrandFontVariantsForMainFont = async ({
    mainFontId,
  }: {
    mainFontId: string;
  }) => {
    try {
      const res = await axiosInstance.get(
        `/brand-fonts/variants/for-main-font`,
        {
          params: { main_font_id: mainFontId },
        },
      );
      return { success: true, data: res.data?.data?.docs };
    } catch (err: any) {
      return {
        success: false,
        error:
          err?.response?.data?.message ||
          "Something went wrong while fetching brand settings!",
        data: err?.response?.data,
      };
    }
  };

  const getAgencyFontVariantsForMainFont = async ({
    mainFontId,
  }: {
    mainFontId: string;
  }) => {
    try {
      const res = await axiosInstance.get(
        `/agency-fonts/variants/for-main-font`,
        {
          params: { main_font_id: mainFontId },
        },
      );
      return { success: true, data: res.data?.data?.docs };
    } catch (err: any) {
      return {
        success: false,
        error:
          err?.response?.data?.message ||
          "Something went wrong while fetching brand settings!",
        data: err?.response?.data,
      };
    }
  };

  const fetchFontsData = async () => {
    setDesignState((prev) => ({
      ...prev,
      downloadingFontsData: true,
      loading: true,
    }));

    let agencyData = designState.agencyData as any;
    let brandData = designState.brandData as any;

    let isBrandAgency = false;
    if (agencyData?.brand_id) isBrandAgency = true;

    let settingsData = null;
    if (isBrandAgency) {
      settingsData = brandData?.settings;
    } else settingsData = agencyData?.settings;

    let titleFont = settingsData?.title_fonts;
    let subtitleFont = settingsData?.subtitle_fonts;
    let bodyFont = settingsData?.body_text_fonts;

    let titleFontSelectedFrom = settingsData?.title_fonts_selected_from;
    let subtitleFontSelectedFrom = settingsData?.subtitle_fonts_selected_from;
    let bodyFontSelectedFrom = settingsData?.body_text_fonts_selected_from;

    let fontsPromises = [];

    const processFontRequest = async ({
      fontType,
      mainFontId,
      fontVariant,
    }: any) => {
      let fontsData = [];
      if (fontType === "system-fonts") {
        let res = await getSystemFontVariantsForMainFont({ mainFontId });
        if (res?.success && res.data) fontsData = res.data;
      }
      if (fontType === "brand-fonts") {
        let res = await getBrandFontVariantsForMainFont({ mainFontId });
        if (res?.success && res.data) fontsData = res.data;
      }
      if (fontType === "agency-fonts") {
        let res = await getAgencyFontVariantsForMainFont({ mainFontId });
        if (res?.success && res.data) fontsData = res.data;
      }
      return { fonts: fontsData, fontVariant };
    };

    if (titleFont && titleFont != "design_default") {
      if (titleFontSelectedFrom === "system-fonts")
        fontsPromises.push(() =>
          processFontRequest({
            fontType: "system-fonts",
            mainFontId: titleFont,
            fontVariant: "title_font",
          }),
        );
      if (titleFontSelectedFrom === "brand-fonts")
        fontsPromises.push(() =>
          processFontRequest({
            fontType: "brand-fonts",
            mainFontId: titleFont,
            fontVariant: "title_font",
          }),
        );
      if (titleFontSelectedFrom === "agency-fonts")
        fontsPromises.push(() =>
          processFontRequest({
            fontType: "agency-fonts",
            mainFontId: titleFont,
            fontVariant: "title_font",
          }),
        );
    }

    if (subtitleFont && subtitleFont != "design_default") {
      if (subtitleFontSelectedFrom === "system-fonts")
        fontsPromises.push(() =>
          processFontRequest({
            fontType: "system-fonts",
            mainFontId: subtitleFont,
            fontVariant: "subtitle_font",
          }),
        );
      if (subtitleFontSelectedFrom === "brand-fonts")
        fontsPromises.push(() =>
          processFontRequest({
            fontType: "brand-fonts",
            mainFontId: subtitleFont,
            fontVariant: "subtitle_font",
          }),
        );
      if (subtitleFontSelectedFrom === "agency-fonts")
        fontsPromises.push(() =>
          processFontRequest({
            fontType: "agency-fonts",
            mainFontId: subtitleFont,
            fontVariant: "subtitle_font",
          }),
        );
    }

    if (bodyFont && bodyFont != "design_default") {
      if (bodyFontSelectedFrom === "system-fonts")
        fontsPromises.push(() =>
          processFontRequest({
            fontType: "system-fonts",
            mainFontId: bodyFont,
            fontVariant: "body_font",
          }),
        );
      if (bodyFontSelectedFrom === "brand-fonts")
        fontsPromises.push(() =>
          processFontRequest({
            fontType: "brand-fonts",
            mainFontId: bodyFont,
            fontVariant: "body_font",
          }),
        );
      if (bodyFontSelectedFrom === "agency-fonts")
        fontsPromises.push(() =>
          processFontRequest({
            fontType: "agency-fonts",
            mainFontId: bodyFont,
            fontVariant: "body_font",
          }),
        );
    }

    let fontsResults = await Promise.all(fontsPromises.map((task) => task()));

    let titleFonts = [];
    let subtitleFonts = [];
    let bodyFonts = [];

    for (const item of fontsResults) {
      if (item.fontVariant === "title_font") titleFonts.push(item.fonts);
      if (item.fontVariant === "subtitle_font") subtitleFonts.push(item.fonts);
      if (item.fontVariant === "body_font") bodyFonts.push(item.fonts);
    }

    titleFonts = titleFonts.flat();
    subtitleFonts = subtitleFonts.flat();
    bodyFonts = bodyFonts.flat();

    function uniqueById(arr: any) {
      const result = [];
      const seen = new Set();
      for (const item of arr) {
        if (!seen.has(item._id)) {
          seen.add(item._id);
          result.push(item);
        }
      }
      return result;
    }

    let updatedTitleFonts = uniqueById(titleFonts) as any;
    let updatedSubtitleFonts = uniqueById(subtitleFonts) as any;
    let updatedBodyFonts = uniqueById(bodyFonts) as any;

    let designFontsData = designState.agencyFontsData as any;

    for (const [index, element] of updatedTitleFonts.entries()) {
      let weight = element.font_weight;
      let isItalic = element.is_italic;
      let fontKey = `font_${weight}`;
      let loadFont = true;
      let weightIdentifier = String(weight);

      if (isItalic) {
        weightIdentifier = `${weight}_italic`;
        fontKey = `${fontKey}_italic`;
      }
      updatedTitleFonts[index].load_font = loadFont;

      if (designFontsData.title?.[fontKey]) {
        designFontsData.title[fontKey] = {
          loaded: false,
          error: false,
          postscript_name: element.postscript_name,
          load_font: loadFont,
        };
      }
    }

    for (const [index, element] of updatedSubtitleFonts.entries()) {
      let weight = element.font_weight;
      let isItalic = element.is_italic;
      let fontKey = `font_${weight}`;
      let loadFont = true;
      let weightIdentifier = String(weight);

      if (isItalic) {
        weightIdentifier = `${weight}_italic`;
        fontKey = `${fontKey}_italic`;
      }
      updatedSubtitleFonts[index].load_font = loadFont;

      if (designFontsData.subtitle?.[fontKey]) {
        designFontsData.subtitle[fontKey] = {
          loaded: false,
          error: false,
          postscript_name: element.postscript_name,
          load_font: loadFont,
        };
      }
    }

    for (const [index, element] of updatedBodyFonts.entries()) {
      let weight = element.font_weight;
      let isItalic = element.is_italic;
      let fontKey = `font_${weight}`;

      if (isItalic) fontKey = `${fontKey}_italic`;
      let loadFont = true;
      let weightIdentifier = String(weight);

      if (isItalic) {
        weightIdentifier = `${weight}_italic`;
        fontKey = `${fontKey}_italic`;
      }
      updatedBodyFonts[index].load_font = loadFont;

      if (designFontsData.body?.[fontKey]) {
        designFontsData.body[fontKey] = {
          loaded: false,
          error: false,
          postscript_name: element.postscript_name,
          load_font: loadFont,
        };
      }
    }

    let allFonts = [
      ...updatedTitleFonts,
      ...updatedSubtitleFonts,
      ...updatedBodyFonts,
    ];

    allFonts = uniqueById(allFonts);

    preloadFonts({
      agencyFontsData: designFontsData,
      fontsToBeLoaded: allFonts,
    });
  };

  useEffect(() => {
    let agencyData: AgencyData = designState?.agencyData as any;
    if (!agencyData) return;
    if (agencyData && agencyData?.brand_id && !designState.brandData) return;
    fetchFontsData();
  }, [designState.agencyData, designState.brandData]);

  const getCanvasImage = (stageKey: string, group: string) => {
    const containerId = `container-${stageKey}-${group}`;
    const element = document.getElementById(containerId);
    if (!element) return null;
    const canvas =
      (element.querySelector("canvas.lower-canvas") as HTMLCanvasElement) ||
      element.querySelector("canvas");
    return canvas ? canvas.toDataURL("image/png") : null;
  };

  const handleDownload = (stageKey: string, group: string) => {
    const dataUrl = getCanvasImage(stageKey, group);
    if (!dataUrl) return;
    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = `${stageKey}-${group}.png`;
    link.click();
  };

  const handleOpenPreview = (stageKey: string, group: string) => {
    const dataUrl = getCanvasImage(stageKey, group);
    if (!dataUrl) return;
    setPreviewImages([dataUrl]);
    setPreviewOpen(true);
  };

  const handleToggleView = (stageKey: string, group: string) => {
    const toggleKey = `${stageKey}-${group}`;
    setViewMap((prev) => ({
      ...prev,
      [toggleKey]: prev[toggleKey] === "story" ? "image" : "story",
    }));
  };

  // const handleEditClick = (stageLabel: string, stageSlug: string) => {
  //   const stageSpecificId =
  //     fullConfig?.updated_marketing_stages?.[stageSlug]?.design_record_id?._id;

  //   const currentActiveId =
  //     stageSpecificId || fullConfig?.design_record_id?._id;

  //   setSelectedStageData({
  //     label: stageLabel,
  //     stageSlug: stageSlug,
  //     post_type: fullConfig?.post_type || "image_story_post",
  //     activeDesignId: currentActiveId,
  //   });
  //   setIsModalOpen(true);
  // };

  const handleEditClick = (stageLabel: string, stageSlug: string) => {
    const stageSpecificId =
      fullConfig?.updated_marketing_stages?.[stageSlug]?.design_record_id?._id;

    const currentActiveId =
      stageSpecificId || fullConfig?.design_record_id?._id;

    const mappedSlug = mapDesignStageToPropertyStageSlug(stageSlug);
    const dynamicLabel = getSelectedStageDisplayTitle({
      stages: stageConfigs,
      stageSlug: mappedSlug,
      stageName: stageLabel,
      fallbackLabel: stageLabel,
      uppercase: true,
    });

    setSelectedStageData({
      label: stageLabel,
      stageSlug: stageSlug,
      post_type: fullConfig?.post_type || "image_story_post",
      activeDesignId: currentActiveId,
      dynamicStageLabel: dynamicLabel,
    });
    setIsModalOpen(true);
  };

  const [activeStep, setActiveStep] = useState("property_marketing_for_sale");

  useEffect(() => {
    let cancelled = false;

    const getListingTypeFromStep = (step: string): "sell" | "rent" => {
      // property_marketing_for_rent / agent_marketing_for_rent → rent
      // property_marketing_for_sale / agent_marketing_for_sale → sell
      if (step.endsWith("_for_rent") || step.includes("for_rent")) {
        return "rent";
      }
      return "sell";
    };

    const loadStages = async () => {
      const listingType = getListingTypeFromStep(activeStep);

      setStagesLoading(true);
      // pehle purana data clear, taaki galat sale/rent titles na dikhein
      setStageConfigs([]);

      try {
        // 🔥 step change pe hamesha FRESH API call (cache mat use karo yahan)
        const res = await PropertyApi.getAllStagesWithTitles(listingType);

        if (cancelled) return;

        if (res?.data?.success && Array.isArray(res.data.data)) {
          setStageConfigs(res.data.data);
        } else {
          setStageConfigs([]);
        }
      } catch (e) {
        console.error("Failed to fetch stage configs", e);
        if (!cancelled) setStageConfigs([]);
      } finally {
        if (!cancelled) setStagesLoading(false);
      }
    };

    loadStages();

    return () => {
      cancelled = true;
    };
  }, [activeStep]);

  return (
    <ProtectedComponent>
      <NavigationLayout>
        <div className="master-design-configure-container standard-templates-list-container">
          <div
            className="propertie-view-back-btn"
            onClick={() =>
              navigate(`${clientRoutes.designTemplateTypes}?type=${type}`)
            }
          >
            <div className="back-icon">
              <BackArrowIcon />
            </div>
            <p className="bakc-text-contain">Back</p>
          </div>

          <p className="page-title">Master design configuration</p>
          <p className="page-sub-title">
            Manage designs across all marketing stages for the master design
          </p>

          <div className="step-tabs">
            {Object.keys(STEP_MAPPING).map((stepKey) => (
              <div
                key={stepKey}
                className={`tab ${activeStep === stepKey ? "active" : ""}`}
                onClick={() => setActiveStep(stepKey)}
              >
                {STEP_LABELS[stepKey]}
              </div>
            ))}
          </div>

          <div className="step-section">
            <div className="step-title">
              Design setup - {STEP_LABELS[activeStep]} stages
            </div>

            <p className="step-subtitle">
              Review or edit your marketing designs
            </p>

            {/* {loading || designState.downloadingFontsData ? ( */}
            {loading || designState.downloadingFontsData || stagesLoading ? (
              <div className="font-loader-wrapper">
                <div className="font-loader-container">
                  <div className="loader-spinner">
                    <div className="spinner-inner"></div>
                  </div>
                  <p className="loader-text">Initializing agency data...</p>
                </div>
              </div>
            ) : designState.loadingFontsData ? (
              <div className="font-loader-wrapper">
                <div className="font-loader-container">
                  <div className="loader-spinner">
                    <div className="spinner-inner"></div>
                  </div>
                  <p className="loader-text">Loading fonts data...</p>
                </div>
              </div>
            ) : (
              <div className="stage-row">
                {STEP_MAPPING[activeStep].map((stageKey: string) => {
                  const stage = data?.[stageKey];
                  if (!stage) return null;

                  const isOpenHome = stageKey.includes("open_home");

                  const hasMasterAgencyFile =
                    data?.agency_open_home_image_post_master_design_svg_file
                      ?.upload_record_id ||
                    data?.agency_open_home_story_post_master_design_svg_file
                      ?.upload_record_id;

                  const hasStageAgencyFile =
                    stage?.agency_image_post_master_design_svg_file
                      ?.upload_record_id ||
                    stage?.agency_story_post_master_design_svg_file
                      ?.upload_record_id;

                                    const showAgencyCard =
                    isOpenHome && (hasMasterAgencyFile || hasStageAgencyFile);

                  const isFullWidth = showAgencyCard;

                  // 🔥 Map slug and calculate labels
                  const stageSlug = mapDesignStageToPropertyStageSlug(stageKey);

                  // 1. Header (Title case eg: "Coming Soon To Buy")
                  const headerStageLabel = getSelectedStageDisplayTitle({
                    stages: stageConfigs,
                    stageSlug: stageSlug,
                    stageName: stage?.stage_label,
                    fallbackLabel: stage?.stage_label,
                    uppercase: false,
                  });

                  // 2. Design Card Image/Story text (Uppercase eg: "COMING SOON TO BUY")
                  const designStageLabel = getSelectedStageDisplayTitle({
                    stages: stageConfigs,
                    stageSlug: stageSlug,
                    stageName: stage?.stage_label,
                    fallbackLabel: stage?.stage_label,
                    uppercase: true,
                  });

                  return (
                    <div
                      className={`stage-block ${isFullWidth ? "full-width-stage" : ""}`}
                      key={stageKey}
                    >
                      <div className="stage-header">
                        <img src="/images/image-placeholder.svg" alt="" />
                        {/* <span>{stage?.stage_label}</span> */}
                        <span>{headerStageLabel}</span>
                      </div>

                      <div className="designs-split-container">
                        {["agent", "agency"].map((group) => {
                          if (group === "agency" && !showAgencyCard) {
                            return null;
                          }

                          return (
                            <DesignCardItem
                              key={`${stageKey}-${group}`}
                              stageKey={stageKey}
                              group={group}
                              stage={stage}
                              agencyData={agencyData}
                              data={data}
                              fullConfig={fullConfig}
                              agencyFontsData={designState.agencyFontsData}
                              onEditClick={handleEditClick}
                              onDownload={handleDownload}
                              onOpenPreview={handleOpenPreview}
                              dynamicStageLabel={designStageLabel}
                            />
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
        <SelectDesignModal
          show={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSuccess={() => {
            fetchData();
            setIsModalOpen(false);
          }}
          stageLabel={selectedStageData?.label || ""}
          selectedDesignTemplateStageSlug={selectedStageData?.stageSlug || ""}
          selectedDesignTemplateId={selectedStageData?.activeDesignId || ""}
          postType={selectedStageData?.post_type || ""}
          dynamicStageLabel={selectedStageData?.dynamicStageLabel || ""}
        />
        <PreviewModal
          open={previewOpen}
          onClose={() => setPreviewOpen(false)}
          images={previewImages}
        />
      </NavigationLayout>
    </ProtectedComponent>
  );
};

export default MasterDesignConfigure;
